import { ArrowLeft } from 'lucide-react'

export default function PrivacyTermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        {/* Header */}
        <div className="flex items-center gap-4 mb-12">
          <button 
            onClick={() => window.history.back()}
            className="p-2 hover:bg-neutral-100 rounded-lg transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-neutral-700" />
          </button>
          <div>
            <h1 className="text-3xl font-bold text-neutral-900">
              Điều khoản sử dụng và Chính sách bảo mật
            </h1>
            <p className="text-neutral-600 mt-2">
              Cập nhật lần cuối: 31/8/2025
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="prose prose-lg max-w-none text-neutral-800 leading-relaxed space-y-8">
          
          <h2 className="text-2xl font-bold text-neutral-900 mb-6">Điều khoản sử dụng (Terms of Service)</h2>
          
          <h3 className="text-xl font-semibold text-neutral-900 mb-4">1. Chấp nhận điều khoản</h3>
          <p className="mb-4">
            Khi đăng ký và sử dụng MeBi App, bạn xác nhận đã đọc, hiểu và đồng ý tuân thủ các Điều khoản này. Nếu bạn không đồng ý, vui lòng không sử dụng dịch vụ.
          </p>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">2. Đăng ký và tài khoản</h3>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>Người dùng cần cung cấp thông tin chính xác, đầy đủ và cập nhật khi đăng ký.</li>
            <li>Một số chức năng chỉ khả dụng sau khi tài khoản được xác thực (qua số điện thoại/OTP hoặc mã thành viên do Liên đoàn cấp).</li>
            <li>Người dùng chịu trách nhiệm bảo mật thông tin tài khoản, bao gồm mật khẩu và mã OTP.</li>
          </ul>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">3. Quyền và trách nhiệm của người dùng</h3>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>Người dùng không được sử dụng ứng dụng vào các mục đích gian lận, vi phạm pháp luật hoặc gây ảnh hưởng đến hoạt động của hệ thống.</li>
            <li>Người dùng cần tuân thủ quy định khi đăng ký giải đấu, nộp lệ phí và tham gia thi đấu.</li>
            <li>Người dùng chịu trách nhiệm với thông tin, nội dung do mình cung cấp.</li>
          </ul>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">4. Quyền và trách nhiệm của MeBi App</h3>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>MeBi có quyền từ chối hoặc hủy bỏ tài khoản trong trường hợp phát hiện vi phạm điều khoản.</li>
            <li>MeBi có thể thay đổi, cập nhật hoặc tạm ngưng một phần/tổng thể dịch vụ để bảo trì hoặc nâng cấp.</li>
            <li>MeBi cam kết bảo mật dữ liệu cá nhân theo Chính sách bảo mật đi kèm.</li>
          </ul>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">5. Trách nhiệm pháp lý</h3>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>MeBi không chịu trách nhiệm cho các thiệt hại phát sinh từ hành vi vi phạm điều khoản hoặc lỗi từ phía người dùng.</li>
            <li>Các tranh chấp liên quan đến giải đấu sẽ do Ban tổ chức giải và Liên đoàn giải quyết theo quy định hiện hành.</li>
          </ul>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">6. Sửa đổi điều khoản</h3>
          <p className="mb-8">
            MeBi có quyền thay đổi Điều khoản sử dụng bất kỳ lúc nào. Phiên bản cập nhật sẽ được công bố trong ứng dụng. Người dùng tiếp tục sử dụng đồng nghĩa với việc chấp nhận các thay đổi.
          </p>

          <h2 className="text-2xl font-bold text-neutral-900 mb-6">Chính sách bảo mật (Privacy Policy)</h2>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">1. Mục đích thu thập thông tin</h3>
          <p className="mb-3">
            MeBi thu thập thông tin cá nhân (tên, số điện thoại, email, mã thành viên, thông tin thanh toán...) để:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>Xác thực tài khoản và quản lý người dùng.</li>
            <li>Hỗ trợ đăng ký và quản lý giải đấu.</li>
            <li>Cập nhật thông báo, lịch thi đấu và kết quả.</li>
            <li>Nâng cao trải nghiệm và bảo mật hệ thống.</li>
          </ul>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">2. Phạm vi sử dụng thông tin</h3>
          <p className="mb-3">
            Thông tin người dùng được sử dụng cho các mục đích:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li>Quản lý tài khoản và giải đấu.</li>
            <li>Liên hệ hỗ trợ, thông báo lịch và kết quả thi đấu.</li>
            <li>Nghiên cứu, phân tích dữ liệu để cải thiện dịch vụ.</li>
          </ul>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">3. Chia sẻ thông tin</h3>
          <p className="mb-3 font-medium">
            MeBi không bán, trao đổi thông tin cá nhân cho bên thứ ba.
          </p>
          <p className="mb-3">Các trường hợp chia sẻ thông tin:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li><strong>Với đối tác liên quan:</strong> Chia sẻ thông tin cần thiết với Liên đoàn Cầu lông Việt Nam và ban tổ chức giải đấu để quản lý giải đấu.</li>
            <li><strong>Theo yêu cầu pháp luật:</strong> Trường hợp có yêu cầu từ cơ quan pháp luật, MeBi có thể cung cấp dữ liệu theo quy định.</li>
          </ul>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">4. Bảo mật dữ liệu</h3>
          <p className="mb-4">
            Lưu trữ an toàn trên máy chủ đáp ứng tiêu chuẩn bảo mật hợp lý; áp dụng mã hóa, phân quyền, ghi log truy cập.
          </p>
          <p className="mb-4">
            Dữ liệu cá nhân được lưu giữ trong thời gian cần thiết cho mục đích nêu trên hoặc theo yêu cầu pháp luật.
          </p>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">5. Quyền của chủ thể dữ liệu</h3>
          <p className="mb-3">Bạn có quyền yêu cầu MeBi:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li><strong>Truy cập dữ liệu:</strong> Cung cấp thông tin về dữ liệu cá nhân đang được xử lý</li>
            <li><strong>Chỉnh sửa dữ liệu:</strong> Sửa chữa dữ liệu không chính xác hoặc không đầy đủ</li>
            <li><strong>Xóa dữ liệu:</strong> Xóa dữ liệu cá nhân trong các trường hợp nhất định</li>
            <li><strong>Rút lại đồng ý:</strong> Thu hồi sự đồng ý xử lý dữ liệu đã cấp trước đó</li>
            <li><strong>Khiếu nại:</strong> Gửi khiếu nại đến cơ quan bảo vệ dữ liệu có thẩm quyền</li>
            <li><strong>Di chuyển dữ liệu:</strong> Nhận dữ liệu ở định dạng có cấu trúc, thông dụng</li>
          </ul>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">6. Thời gian lưu trữ dữ liệu</h3>
          <p className="mb-4">
            Dữ liệu cá nhân sẽ được lưu trữ trong thời gian cần thiết để thực hiện các mục đích đã nêu hoặc theo quy định pháp luật:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2">
            <li><strong>Thông tin tài khoản:</strong> Trong suốt thời gian tài khoản hoạt động và tối đa 2 năm sau khi tài khoản bị xóa hoặc không hoạt động</li>
            <li><strong>Dữ liệu giải đấu:</strong> Tối đa 5 năm kể từ khi giải đấu kết thúc để phục vụ mục đích thống kê và lưu trữ lịch sử</li>
            <li><strong>Log hệ thống:</strong> Tối đa 12 tháng để phục vụ mục đích bảo mật, khắc phục sự cố và cải thiện dịch vụ</li>
            <li><strong>Dữ liệu pháp lý:</strong> Theo thời hạn quy định của pháp luật Việt Nam hoặc yêu cầu của cơ quan có thẩm quyền</li>
          </ul>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">7. Sử dụng Cookie</h3>
          <p className="mb-4">
            MeBi sử dụng cookie và các công nghệ tương tự để cải thiện trải nghiệm người dùng, phân tích lưu lượng truy cập và cá nhân hóa nội dung. Bạn có thể quản lý cookie thông qua cài đặt trình duyệt.
          </p>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">8. Chuyển giao dữ liệu xuyên biên giới</h3>
          <p className="mb-4">
            Dữ liệu cá nhân có thể được chuyển giao và xử lý tại các quốc gia khác nhau để cung cấp dịch vụ. MeBi đảm bảo áp dụng các biện pháp bảo mật phù hợp trong quá trình chuyển giao.
          </p>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">9. Cập nhật chính sách</h3>
          <p className="mb-4">
            Chính sách bảo mật này có thể được cập nhật định kỳ. Phiên bản mới nhất sẽ được thông báo qua ứng dụng hoặc email. Ngày cập nhật cuối cùng được ghi rõ ở đầu tài liệu.
          </p>

          <h3 className="text-xl font-semibold text-neutral-900 mb-4">10. Thông tin liên hệ</h3>
          <p className="mb-4">
            Nếu bạn có bất kỳ câu hỏi nào về Chính sách bảo mật này hoặc muốn thực hiện các quyền của mình, vui lòng liên hệ:
          </p>
          <ul className="list-none space-y-2 mb-8">
            <li><strong>Email:</strong> support@mebi.vn</li>
            <li><strong>Điện thoại:</strong> +84 123 456 789</li>
            <li><strong>Địa chỉ:</strong> Nền tảng quản lý giải đấu cầu lông chuyên nghiệp</li>
          </ul>

  
        </div>
      </div>
    </div>
  )
}